var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-614.439232,-354.24345)"
  }, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.052375,0,0,1.052375,-45.180744,-15.447171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M675.708,404.708L675.708,417C675.708,418.496 674.496,419.708 673,419.708L635,419.708C633.504,419.708 632.292,418.496 632.292,417L632.292,367C632.292,365.504 633.504,364.292 635,364.292L646.74,364.292L646.74,354C646.74,352.504 647.952,351.292 649.448,351.292L687,351.292C688.496,351.292 689.708,352.504 689.708,354L689.708,402C689.708,403.496 688.496,404.708 687,404.708L675.708,404.708ZM652.156,364.292L673,364.292C674.496,364.292 675.708,365.504 675.708,367L675.708,399.292L684.292,399.292L684.292,356.708L652.156,356.708L652.156,364.292ZM670.292,369.708L637.708,369.708L637.708,414.292L670.292,414.292L670.292,369.708ZM645,391.158C643.505,391.158 642.292,389.944 642.292,388.449C642.292,386.955 643.505,385.741 645,385.741L663,385.741C664.495,385.741 665.708,386.955 665.708,388.449C665.708,389.944 664.495,391.158 663,391.158L645,391.158ZM645,380.708C643.505,380.708 642.292,379.495 642.292,378C642.292,376.505 643.505,375.292 645,375.292L663,375.292C664.495,375.292 665.708,376.505 665.708,378C665.708,379.495 664.495,380.708 663,380.708L645,380.708ZM666.708,399L666.708,407C666.708,408.496 665.496,409.708 664,409.708L644,409.708C642.504,409.708 641.292,408.496 641.292,407L641.292,399C641.292,397.504 642.504,396.292 644,396.292L664,396.292C665.496,396.292 666.708,397.504 666.708,399ZM661.292,401.708L646.708,401.708L646.708,404.292L661.292,404.292L661.292,401.708Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.765957,0,0,0.782609,287.375402,78.765189)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 427,
    y: 352,
    width: 94,
    height: 92,
    style: {
      fill: "none"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/ICON3.244b53af2d610f2a013e71427d5db0b1.svg";
export { ForwardRef as ReactComponent };